import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { projectGroupList } from "../Stores/ProjectGroupStore";
import { ProjectTemplateOverview } from "./ProjectTemplates/ProjectTemplateOverview";

export const ProjectGroupTemplates = observer(() => {
  const { t } = useTranslation(I18N_NS.ADMIN);
  const { projectGroupId: prGroupId } = useParams();

  React.useEffect(() => {
    if (prGroupId && !projectGroupList.data.length) {
      projectGroupList.fetch();
    }
  }, []);
  return (
    <div className="g-card">
      <h1>
        {t("Template-Projects")}
        {prGroupId && (
          <span>
            :<strong> {projectGroupList.getName(prGroupId)}</strong>
          </span>
        )}
      </h1>
      <ProjectTemplateOverview projectGroupId={prGroupId} />
    </div>
  );
});
